import PropTypes from 'prop-types'
import { progressBarSizeOptions } from '../constants'
import { ProgressContainer, Container } from '../styled-components'
import ButtonComponent from '../../button'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../../button/constants'
import { Cancel } from '../../icons/essentials'
import { ProgressBarLoading } from './progress-bar-loading'

const ProgressBarRoot = ({
  progressBarValue = 0,
  size = progressBarSizeOptions.SMALL,
  isLoading = false,
  loadingLabel = null,
  loadingProgressLabel = null,
  loadingHint = null,
  cancelButton = false,
  cancelOnClick = () => {},
  children
}) => {
  const buttonSize =
    size === progressBarSizeOptions.LARGE
      ? buttonSizeOptions.MEDIUM
      : buttonSizeOptions.SMALL

  if (isLoading) {
    return (
      <ProgressBarLoading
        size={size}
        loadingLabel={loadingLabel}
        loadingProgressLabel={loadingProgressLabel}
        loadingHint={loadingHint}
      />
    )
  }

  if (progressBarValue < 0) {
    return null
  }

  return (
    <Container>
      <ProgressContainer>{children}</ProgressContainer>
      {cancelButton && !isLoading && (
        <ButtonComponent
          variant={buttonVariantOptions.GHOST}
          size={buttonSize}
          buttonType={buttonTypeOptions['ICON-ONLY']}
          onClick={cancelOnClick}
        >
          <Cancel />
        </ButtonComponent>
      )}
    </Container>
  )
}

ProgressBarRoot.propTypes = {
  progressBarValue: PropTypes.number,
  cancelButton: PropTypes.bool,
  cancelOnClick: PropTypes.func,
  size: PropTypes.oneOf(Object.values(progressBarSizeOptions)),
  isLoading: PropTypes.bool,
  loadingLabel: PropTypes.node,
  loadingProgressLabel: PropTypes.node,
  loadingHint: PropTypes.node,
  children: PropTypes.node
}

export default ProgressBarRoot
